import React, { Component } from "react";
import "./App.css";
import { Route, BrowserRouter, Switch, Redirect } from "react-router-dom";
import Home from "./components/Home";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import ExitPopupModal from "./PopupModal/ExitPopupModal";
import idleDesktopImg from "./images/idleDesktopImg.png";
import idleMobileImage from "./images/idleMobileImage.png";
import react from "react";
import IdleTimer from "react-idle-timer";
// import BeforeUnloadComponent from "react-beforeunload-component";
// import { Beforeunload } from 'react-beforeunload';

class App extends Component {
	constructor(props) {
		super(props);
		this.idleTimer = null;
		this.handleOnIdle = this.handleOnIdle.bind(this);
		this.state = {
			isModal: false,
			isIdleModal: false,
			idlePopupData: {
				DesktopImg: idleDesktopImg,
				MobileImg: idleMobileImage,
				Heading: `Become a top teaching brand is just one step away.`,
				SubHeading: `Over 50,000 teachers from 1,100+ cities have launched their apps and are growing their teaching business by 5x`,
			},
		};
	}

	// onUnload = event => {
	// 	event.preventDefault();
	// 	this.setState({ isModal: true });
	// }

	componentDidMount() {
		// window.addEventListener("beforeunload", (e) => {
		// 	e.preventDefault();
		// 	if (typeof e == 'undefined') {
		// 		e = window.event;
		// 	}
		// 	if (e) {
		// 		e.returnValue = this.setState({ isModal: true });
		// 	}
		// 	return this.setState({ isModal: true });
		// });
	}

	// componentWillUnmount() {
	// 	window.removeEventListener("beforeunload", this.onUnload);
	// }

	handleModalBtn = () => {
		this.setState({ isModal: false });
	};

	handleIdleModalBtn = () => {
		this.setState({ isIdleModal: false });
	};

	handleOnIdle() {
		let classplusFormSubmitted = localStorage.getItem("classplusFormSubmitted");
		if (!classplusFormSubmitted) {
			this.setState({ isIdleModal: true });
		}
	}

	render() {
		let { isModal, isIdleModal, idlePopupData } = this.state;
		return (
			<react.Fragment>
				<div>
					<IdleTimer
						ref={(ref) => {
							this.idleTimer = ref;
						}}
						timeout={1000 * 180}
						onIdle={this.handleOnIdle}
						debounce={250}
					/>
					<div className="App">
						<NavBar />
						<Home />
						<div style={{ display: "none" }}>
							<button
								onClick={() => {
									this.setState({ isModal: true });
								}}
								style={{ width: "40%", margin: "auto" }}
							>
								Exit modal
              </button>
							<button
								onClick={() => {
									this.setState({ isIdleModal: true });
								}}
								style={{ width: "40%", margin: "16px auto" }}
							>
								Idle modal
              </button>
						</div>
						<Footer />
						{/*<BrowserRouter>
						<Switch>
							<Route exact path="/" component={Home} />
							<Route render={() => <Redirect to="/" />} />
						</Switch>
					</BrowserRouter>
					*/}
					</div>
				</div>
				<ExitPopupModal
					isModal={isModal}
					handleModalBtn={this.handleModalBtn}
				/>
				<ExitPopupModal
					isModal={isIdleModal}
					handleModalBtn={this.handleIdleModalBtn}
					idlePopupData={idlePopupData}
				/>
			</react.Fragment>
		);
	}
}

export default App;
